import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "thumbnail"]

  initialize() {
    console.log("Image switcher initialized")
  }

  connect() {
    console.log("Image switcher connected", {
      mainImageTarget: this.hasMainImageTarget,
      thumbnailTargets: this.thumbnailTargets.length
    })
  }

  disconnect() {
    console.log("Image switcher disconnected")
  }

  switch(event) {
    event.preventDefault()
    
    const thumbnail = event.currentTarget
    const imageUrl = thumbnail.dataset.imageUrl
    
    if (this.hasMainImageTarget && imageUrl) {
      this.mainImageTarget.src = imageUrl
      
      // Update active state of thumbnails
      this.thumbnailTargets.forEach(thumb => {
        thumb.classList.toggle('active', thumb === thumbnail)
      })
    }
  }
} 